module.exports = __webpack_public_path__ + "static/img/016.70c12a34.png";